import React, {useContext} from "react";
import {useLocation} from "react-router-dom";

import TopMenu from "../top-menu";
import TopFilter from "../top-filter";
import SearchFilter from "../search-filter";
import LandingHeaderContent from "./LandingHeaderContent";
import {configMenuLinks} from "../../config";
import {AppContext} from "../../contexts/app-context";
import {
  BUYER,
  WAREHOUSE_WORKER,
} from "../../helpers/user_role.helper";
import {
  isGuestPublicHeaderPath,
  isPublicSitePath,
} from "../../presentation/public-site/route-policy";

function Header({user, onUserTypeChanged}) {
  const location = useLocation();
  const appContext = useContext(AppContext);
  const isPublicSitePage = isPublicSitePath(location.pathname);
  const isAuthenticated = Boolean(user && !user.isGuest());
  const usePublicHeader = Boolean(
      location.pathname === "/" ||
      (
          !isAuthenticated &&
          (
              isPublicSitePage ||
              isGuestPublicHeaderPath(
                  location.pathname
              )
          )
      )
  );

  let userLinks = [];

  if (!usePublicHeader) {
    if (user && user.isGuest()) {
      userLinks = configMenuLinks.guest;
    } else if (user && user.info.role === WAREHOUSE_WORKER) {
      userLinks = configMenuLinks[WAREHOUSE_WORKER];
    } else if (user && user.info.role === BUYER) {
      userLinks = configMenuLinks[BUYER];
    } else {
      userLinks = configMenuLinks.auth;
    }
  }

  const topMenuUserLinks = userLinks.filter((linkData) => {
    if (Array.isArray(linkData.accessTo)) {
      return linkData.accessTo.some((permission) => (
          user && user.isAccessTo(permission)
      ));
    }

    return user && user.isAccessTo(linkData.accessTo);
  });

    const canShowApplicationFilters = Boolean(
        !usePublicHeader &&
        !isPublicSitePage
    );

    const topFilter = (
        canShowApplicationFilters &&
        appContext.filter.enable
            ? <TopFilter/>
            : null
    );

    const searchFilter = (
        canShowApplicationFilters &&
        appContext.filter.enableSearch
            ? <SearchFilter/>
            : null
    );

  return (
      <>
        <header
            className={[
              "header",
              usePublicHeader
                  ? "header--landing"
                  : "header--application",
            ].filter(Boolean).join(" ")}
        >
          <div className="header-shell public-site-shell">
            {usePublicHeader ? (
                <LandingHeaderContent/>
            ) : (
                <TopMenu
                    items={topMenuUserLinks}
                    user={user}
                    onUserTypeChanged={onUserTypeChanged}
                />
            )}
          </div>
        </header>

        {topFilter}
        {searchFilter}
      </>
  );
}

export default React.memo(Header);
